import { TextButton } from 'components/common';
import { useContext, useState } from 'react';
import { FilterContext } from 'utils/context';

import { Checkbox, Flex, Icon } from '@project44/manifest-ds';
import { Collapse } from '@project44/material-ui-deprecated';
import { useTranslation } from '@project44/translations-utils';

interface IFilterCheckboxProps {
  collapsible?: boolean;
  id: string;
  options: string[];
}

function FilterCheckbox({ collapsible, options, id }: IFilterCheckboxProps) {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(!collapsible);
  const { filters, setFiltersKey } = useContext(FilterContext);
  const filter = (filters[id] as string[]) || [];

  const handleCheckbox = (name: string) => (isSelected: boolean) => {
    if (isSelected) {
      setFiltersKey(id, filter.concat(name));
    } else {
      setFiltersKey(
        id,
        filter.filter((sel) => sel !== name),
      );
    }
  };

  return (
    <Flex data-testid="filter-checkbox" wrap>
      <Collapse
        in={isExpanded}
        collapsedSize="51px"
        style={{ padding: 0, width: '100%' }}
      >
        <Flex wrap css={{ gap: '12px' }}>
          {options.map((option) => (
            <Flex key={option} css={{ flexBasis: '48%' }}>
              <Checkbox
                aria-label={t('core.filterCheckboxLabel', { option })}
                isSelected={!!filter.includes(option)}
                onChange={handleCheckbox(option)}
              >
                {t(option)}
              </Checkbox>
            </Flex>
          ))}
        </Flex>
      </Collapse>

      {collapsible && (
        <TextButton
          css={{ marginTop: '$medium' }}
          endIcon={
            <Icon
              icon="expand_more"
              css={{
                color: '$palette-black',
                fontSize: '$small',
                transition: 'transform 250ms',
                ...(isExpanded && { transform: 'rotateX(0.5turn)' }),
              }}
            />
          }
          onClick={() => setIsExpanded(!isExpanded)}
          text={t(isExpanded ? 'global.seeLess' : 'global.seeMore')}
        />
      )}
    </Flex>
  );
}

export default FilterCheckbox;
